import { createSelector } from 'reselect';

import { ServicesEnum, UserRoleEnum } from '../types';

import { memoizedSelectUserRoles } from './selectUserRoles';

import { memoizedSelectCustomerServices } from './selectCustomerServices';

export interface RolesAndServices {
  services: Set<ServicesEnum>;
  roles: Set<UserRoleEnum>;
}

export const memoizedSelectRolesAndServices = createSelector(
  [memoizedSelectCustomerServices, memoizedSelectUserRoles],
  (services, roles) => {
    return {
      services,
      roles,
    };
  },
);
